import { ContentNugget } from '@backrs_ui/common-ui';

import { toAgentContextNugget } from '@backrs_ui/grow-ui/src/agentContext/toAgentContextNugget';
import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

type UseAgentContextArgs = Readonly<{
  nuggets: readonly ContentNugget[];
  /** Names the row, so a page showing several can tell them apart. */
  label?: string;
}>;

export const useAgentContext = ({ nuggets, label }: UseAgentContextArgs) => {
  useRegisterAgentContext(
    nuggets.length > 0
      ? {
          kind: 'nuggetList',
          description: `Tools and resources shown in ${
            label ?? "this guide's Tools and Resources row"
          }. Use these ids when the user asks which one to start with.`,
          nuggets: nuggets.map(toAgentContextNugget),
        }
      : null,
  );
};
